// import {  useEffect, useState } from "react";
import { useEffect, useState } from 'react';

import Mainmenu from './MainMenu';
// import LoadingDots from "./LoadingDots";

import bot from '../../assets/images/happy.png'
import Frame1 from './Frame1';


const Greetings = () => {
    const [time] = useState(new Date());


    const getGreeting = () => {
        const hours = time.getHours();
        if (hours < 12) return "Good Morning";
        if (hours < 18) return "Good Afternoon";
        return "Good Evening";
      };
      const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simulate fetching data
    setTimeout(() => setLoading(false), 1000); 
  }, []);
    return(
        <>
        <div className='chatbot'>
            <img src={bot} alt="bot" className="bot" />
            <div className='chatbot-time'>{time.toLocaleTimeString()}</div>
            </div>
            <div className="frame1 animated-frame">
            <strong>{getGreeting()}</strong>, Greetings from Hegde Fertility<br/>
            </div>
            <div className="frame1 animated-frame">
            <strong>Hegde Fertility</strong> is a leading fertility and reproductive healthcare center in Hyderabad, 
            dedicated to offering world-class treatments with a  compassionate approach. 
            Driven by innovation and backed by advanced technology, we are committed to bringing new 
            hope to families and transforming lives through excellence in fertility care.

            </div>
            <Frame1 />
        </>
    );
}
export default Greetings;   